<template>
  <div id="Resource">
    <van-nav-bar
      title="2020年度经验分享"
      right-text="关闭"
      style="background-color:#DDDDDD"
      @click-right="onClickBack"
    />
    <van-row v-for="item in resourceList" :id="item.article_code" :key="item.article_code" style="border-bottom:1px solid;border-color:#999999" @click="resourceDetail(item)">
      <van-col span="6">
        <van-row>
          <van-col span="2" />
          <van-col span="18">
            <van-image
              width="5.5rem"
              height="5.5rem"
              fit="contain"
              src="https://img.yzcdn.cn/vant/cat.jpeg"
            />
          </van-col>
        </van-row>
      </van-col>
      <van-col span="17" style="margin-left:10px">
        <van-row><span class="article_title">{{ item.article_title }}</span></van-row>
        <van-row><span class="article_content">{{ item.article_abstruct.substr(0,35)+'...' }} </span></van-row>
        <van-row style="height:5px" />
        <van-row>
          <van-col span="15" class="pub_time">{{ timesAll }}</van-col>
          <van-col><van-icon size="18" name="good-job-o" /><label style="margin-left:2px;" class="like_c">{{ item.liked }}</label></van-col>
          <van-col class="like"><van-icon size="18" name="eye-o" /><label style="margin-left:2px;" class="view_c">{{ item.view_count }}</label></van-col>
        </van-row>
      </van-col>
      <van-divider />
    </van-row>
    <van-popup
      v-model="popupleaveCreate"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <resourcevice ref="resource" :parms="parm" :mode="leavePage.mode" :info="leavePage.info" />
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import resourcevice from './ResourceVice'
// const moment = require('moment')
export default {
  name: 'Resource',
  components: { resourcevice },
  data() {
    return {
      leavePage: {
        mode: true,
        info: {}
      },
      times: '',
      timesAll: '',
      parm: {},
      articleCode: '',
      popupleaveCreate: false,
      resourceList: null,
      videoURL: null,
      articleAbstruct: ''
    }
  },
  watch: {
  },
  created() {
    const self = this
    request({ url: 'O05/ResourceList/' })
      .then(function(response) {
        // console.log(response)
        self.resourceList = response.data
        response.data.forEach(element => {
          self.articleCode = element.article_code
          self.articleAbstruct = element.article_abstruct
          self.times = new Date(+new Date(element.create_date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
          self.timesAll = (self.times).substring(0, 10)
        })
      })
      .catch(() => {})
  },
  methods: {
    // 关闭当前页
    onClickBack() {
      this.$router.go(-1)
    },
    // 打开页面详情
    resourceDetail(val) {
      const self = this
      request({ url: 'O05/getResource', params: { article_code: val.article_code }})
        .then(function(response) {
          self.videoURL = response.data[0].article_other.split('\\').pop()
        })
        .catch(() => {})
      this.parm = val
      this.popupleaveCreate = true

      request({ url: 'O05/ResourceDetail', params: { article_code: val.article_code, user_code: self.$store.getters.usercode }})
        .then(function(response) {
        })
        .catch(() => {})
    }
  }
}
</script>
<style>
.article_title{
    font-size: 18px;
    color: #333333;
}
.article_content{
    font-size: 14px;
    color: #797979;
}
.pub_time{
    font-size: 12px;
    color: #999999;
}
.article_user{
    font-size: 14px;
    color: #0066CC;
}
.like{
    margin-left: 20px;
    color: #333333;
}
.like_c{
    font-size: 14px;
}
.view_c{
    font-size: 14px;
    color: #333333;
}
</style>

